import React, {useMemo} from 'react';

function QuickFilter({gammes, categories, removeActiveGamme,removeActiveCategory}) {

    const selectedGammes = useMemo(() => {
        return gammes.filter((gamme) => {
          return gamme.isActive;
        })
    }, [gammes])

    const selectedCategories = useMemo(() => {
        return categories.filter((category) => {
            return category.isActive;
        })
    }, [categories])

    return (<div className="quick-filter">
        {selectedGammes.length > 0 &&
            <div className="selected-gammes">
                {
                    selectedGammes.map((gamme) => {
                        return(<div onClick={(e) => {
                            removeActiveGamme(gamme);
                        }} className="gamme-item" key={gamme.id}>
                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="5.5" cy="5.5" r="4.5" stroke="black" strokeWidth="1.2"/>
                                <rect x="2.31836" y="7.53369" width="7.8" height="1.2" transform="rotate(-45 2.31836 7.53369)" fill="black"/>
                                <rect x="7.8335" y="8.38184" width="7.8" height="1.2" transform="rotate(-135 7.8335 8.38184)" fill="black" />
                            </svg>
                            <div>
                                {gamme.title}
                            </div>
                        </div>)
                    })
                }
            </div>
        }
        {selectedCategories.length > 0 &&
            <div className="selected-categories">
                {
                    selectedCategories.map((category) => {
                        return(<div onClick={() => {
                            removeActiveCategory(category);
                        }} className="category-item" key={category.id}>
                            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="5.5" cy="5.5" r="4.5" stroke={category.color} strokeWidth="1.2"/>
                                <rect x="2.31836" y="7.53369" width="7.8" height="1.2" transform="rotate(-45 2.31836 7.53369)" fill={category.color}/>
                                <rect x="7.8335" y="8.38184" width="7.8" height="1.2" transform="rotate(-135 7.8335 8.38184)" fill={category.color} />
                            </svg>
                            <div style={{
                                color: category.color
                            }}>
                                {category.description}
                            </div>
                        </div>)
                    })
                }
            </div>
        }

    </div>);
}

export default QuickFilter;
